/**
 * Show-all button — toggles truncated grids.
 * Works for any pair of [wrap-id, button-id].
 */
export default function setupShowAll() {
  const pairs = [
    ['class-grid-wrap', 'show-all-btn'],
    ['show-grid-wrap', 'show-all-shows-btn'],
    ['teacher-grid-wrap', 'show-all-teachers-btn'],
  ]

  pairs.forEach(([wrapId, btnId]) => {
    const wrap = document.getElementById(wrapId)
    const btn = document.getElementById(btnId)
    if (!wrap || !btn) return

    btn.addEventListener('click', () => {
      wrap.classList.toggle('is-expanded')
      btn.textContent = wrap.classList.contains('is-expanded')
        ? 'Show fewer'
        : btn.dataset.label
    })

    // Store original label for toggling back
    btn.dataset.label = btn.textContent
  })
}
